import { motion } from "framer-motion";
import { skills } from "../data/portfolio";
import { SectionHeader } from "./SectionHeader";

const marqueeItems = [
  ...skills["AI / ML"],
  ...skills.Frameworks,
  ...skills.Languages,
];

export const Skills = () => {
  return (
    <section
      id="skills"
      data-testid="section-skills"
      className="relative py-24 md:py-32 px-5 sm:px-8"
    >
      <div className="max-w-6xl mx-auto">
        <SectionHeader
          testId="skills-header"
          index="03 // skills"
          title="Toolbox"
          sub="Frameworks, languages and tools I reach for when shipping AI/ML projects."
        />

        {/* Marquee */}
        <div className="marquee relative overflow-hidden mb-14 border-y border-white/5 py-6">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#06030f] to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#06030f] to-transparent z-10" />
          <div className="marquee-track flex gap-8 whitespace-nowrap w-max">
            {[...marqueeItems, ...marqueeItems].map((s, i) => (
              <span
                key={`${s}-${i}`}
                className="font-mono text-lg md:text-xl text-white/40 hover:text-purple-300 transition-colors"
              >
                {s} <span className="text-purple-500/50">✦</span>
              </span>
            ))}
          </div>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {Object.entries(skills).map(([cat, list], i) => (
            <motion.div
              key={cat}
              data-testid={`skill-category-${cat.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="glow-card rounded-xl border border-white/10 bg-[#0d0620]/60 p-5"
            >
              <div className="font-mono text-[11px] tracking-widest text-purple-400 uppercase mb-4">
                {cat}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {list.map((s) => (
                  <span
                    key={s}
                    className="text-xs px-2.5 py-1 rounded-md bg-white/[0.03] border border-white/10 text-white/80 hover:border-purple-400/40 hover:text-white transition-colors"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
